module.exports = __webpack_public_path__ + "img/13.27c75990.jpg";